export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtSkladMisto';
export const NAME = 'SkladoveMisto';
